import { initialiseCarousel } from './_helpers'
import { mediaBreakpoints } from '../utils'
import {getElement, getElements} from './../utils/functional'
import 'swiper/swiper.scss';

export default function init ({ el, context }) {
  const moduleClassName = el.dataset.moduleClassName
  const swiperContainer = el.getElementsByClassName(`${moduleClassName}_Carousel`)[0]
  
  const slideClass = `${moduleClassName}_Slide`
  
  window.addEventListener('resize', makeCarousel)
  
  makeCarousel();

  function makeCarousel () {
    var swiperInstance = initialiseCarousel(
      swiperContainer,
      {
        spaceBetween: 20,
        centeredSlides: false,
        slideClass: slideClass,
        slidesPerView: 1.3,
        preloadImages: false,
        watchSlidesProgress: true,
        setWrapperSize: true,
        watchOverflow: true,
        lazy: true,
        loop: false,
        breakpointsInverse: true,
        breakpoints: {
          769: {
            slidesPerView: 2
          },
          1025: {
            slidesPerView: 3
          }
        }
      }
    )
  }
}